import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const PIPELINE_URL_PARAM = 'pipeline';
export const LEAD_URL_PARAM = 'lead';

export function usePipelineLeadUrl(pipelineId: string) {
  const [searchParams, setSearchParams] = useSearchParams();
  const leadId = searchParams.get(LEAD_URL_PARAM);

  const openLead = useCallback(
    (cardId: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set(LEAD_URL_PARAM, cardId);
          next.set(PIPELINE_URL_PARAM, pipelineId);
          return next;
        },
        { replace: false }
      );
    },
    [pipelineId, setSearchParams]
  );

  const closeLead = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(LEAD_URL_PARAM);
        return next;
      },
      { replace: false }
    );
  }, [setSearchParams]);

  return { leadId, openLead, closeLead };
}
